var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLosing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6937_102552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 7L3 12L8 17L9.41 15.59L6.83 13L16 13L16 11L6.83 11L9.41 8.41L8 7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5L20 5L20 19L6 19L6 17L4 17L4 19C4 20.1 4.89 21 6 21L20 21C21.1 21 22 20.1 22 19L22 5C22 3.9 21.1 3 20 3L6 3C4.89 3 4 3.9 4 5L4 7L6 7L6 5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6937_102552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLosing);
export default __webpack_public_path__ + "static/media/icon-losing.d76ee24adbe9a69d31ed4a0785c8ee03.svg";
export { ForwardRef as ReactComponent };